var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-wrapper"},[(_vm.data && _vm.chart_height)?_c('apexchart',{ref:"apex-chart",attrs:{"type":"area","height":_vm.chart_height,"options":_vm.apex.options(_vm.data, _vm.locale, _vm.getTheme()),"series":_vm.apex.series(_vm.data, _vm.label)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }